// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Extension } from 'tiptap'
import { extendCodemirror } from './code_view'
import _CodeMirror from 'codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/xml/xml'
import 'codemirror/addon/selection/active-line'
import 'codemirror/addon/edit/closetag'


export const DEFAULT_CODEMIRROR_OPTIONS = {
  lineNumbers: true,
  lineWrapping: true,
  tabSize: 2,
  tabMode: 'indent',
  mode: 'text/html',
}

export default class CodeView extends Extension {
  constructor(options = {}) {
    super(options)

    // @ts-ignore type
    const codemirror = _CodeMirror
    if (codemirror == null) {
      // eslint-disable-next-line no-console
      console.warn('`CodeView` extension requires the CodeMirror library.')
    } else {
      extendCodemirror(codemirror)
    }

    // @ts-ignore type
    this.options = {
      codemirror,
      codemirrorOptions: {
        ...this.defaultOptions.codemirrorOptions,
        // @ts-ignore type
        ...options.codemirrorOptions,
      },
    }
  }

  // eslint-disable-next-line
  get name() {
    return 'code_view'
  }

  // eslint-disable-next-line
  get defaultOptions() {
    return {
      codemirror: null,
      codemirrorOptions: {
        ...DEFAULT_CODEMIRROR_OPTIONS,
      },
    }
  }

  // eslint-disable-next-line
  commands() {
    return (isCodeViewMode: boolean) => () => !isCodeViewMode
  }
}
